module.exports = __webpack_public_path__ + "img/IMG_6726_L_WoodMatted.58a900d6.jpg";